import environment, { Environment } from '../../../services/environment';
import { strEndsWith } from '../../../services/strings';
import { getLocalItem, getSessionItem } from './browser-storage';
import { getUrlParam } from './url-params';

export function getBookingID() {
    return getUrlParam('id', true);
}

export function getSessionID() {
    return getUrlParam('session', true) || getSessionItem('sessionId');
}

export const assetPrefix = process.env.ASSET_URL || 'error'; // https://cdn.get-e.com/cdn/v0
export const packageVersion = process.env.PACKAGE_VERSION || 'error';
const apiURL = process.env.API_URL || 'error';

export function getApiUrl(): string {
    return apiURL;
    // const sessionUrl = getSessionItem('api-url');
    // return sessionUrl || apiURL;
}

export const inIframe: boolean = (() => {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
})();

export const pageLang: string = document.documentElement.lang;

export const isTest: boolean = !!getLocalItem('debugging')
    || environment === Environment.Development
    || environment === Environment.Testing;

let isExternal;

switch (environment) {
    case Environment.Development:
        isExternal = window.location.host !== 'local.get-e.com:4000';
        break;
    case Environment.Testing:
        isExternal = !strEndsWith(window.location.hostname, '.book-test.get-e.com');
        break;
    case Environment.Accept:
        isExternal = !strEndsWith(window.location.hostname, '.book-accept.get-e.com');
        break;
    default:
        isExternal = !strEndsWith(window.location.hostname, 'book.get-e.com');
        break;
}

export { isExternal };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/services/app-storage.ts